import { ValuableNode } from '../../models/ValuableNode'

export class SchemaUnknownNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Unknown': SchemaUnknownNode
  }
}
